import { EXCLUDE_UNSELLABLE_PRODUCT_CUSTOM_FILTER } from '~/constants/commerceTools';
import { getLocalizedFilter } from '~/helpers/commercetools/graphql/getLocalizedFilter';

export const excludeUnsellableProduct = (languageAndCountry) => {
  return getLocalizedFilter(EXCLUDE_UNSELLABLE_PRODUCT_CUSTOM_FILTER, languageAndCountry);
};
